var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisease(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 48,
    viewBox: "0 0 34 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04248 16.2027C5.04248 9.64048 10.3622 4.3208 16.9243 4.3208C23.4866 4.3208 28.8062 9.64048 28.8062 16.2027C28.8062 18.6027 28.0935 20.8396 26.8679 22.7092C26.4586 23.3333 26.4586 24.1944 26.8679 24.8185C28.0935 26.6881 28.8062 28.9249 28.8062 31.325C28.8062 37.8873 23.4866 43.2069 16.9243 43.2069C10.3622 43.2069 5.04248 37.8873 5.04248 31.325C5.04248 28.9249 5.7552 26.6881 6.98084 24.8185C7.39005 24.1944 7.39005 23.3333 6.98084 22.7092C5.7552 20.8396 5.04248 18.6027 5.04248 16.2027Z",
    fill: "#054089"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9243 6.28462C16.3279 6.28462 15.8442 5.80101 15.8442 5.20445V1.08017C15.8442 0.483607 16.3279 0 16.9243 0C17.5208 0 18.0045 0.483607 18.0045 1.08017V5.20445C18.0045 5.80101 17.5208 6.28462 16.9243 6.28462Z",
    fill: "#054089"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3334 8.43627C22.7573 8.28187 22.4153 7.68957 22.5698 7.11335L23.6372 3.1296C23.7916 2.55337 24.3838 2.21141 24.9602 2.36581C25.5363 2.52021 25.8783 3.11251 25.7238 3.68873L24.6564 7.67248C24.502 8.24871 23.9098 8.59069 23.3334 8.43627Z",
    fill: "#054089"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5157 8.43627C11.0919 8.28187 11.4339 7.68957 11.2795 7.11335L10.212 3.1296C10.0576 2.55337 9.46534 2.21141 8.88912 2.36581C8.31289 2.52021 7.97093 3.11251 8.12533 3.68873L9.19277 7.67248C9.34717 8.24871 9.93947 8.59069 10.5157 8.43627Z",
    fill: "#054089"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2313 12.3894C26.0394 11.8246 26.3417 11.2111 26.9066 11.0193L30.8116 9.69281C31.3765 9.50096 31.9901 9.80332 32.1819 10.3682C32.3738 10.9331 32.0713 11.5465 31.5066 11.7384L27.6014 13.0648C27.0364 13.2567 26.4231 12.9543 26.2313 12.3894Z",
    fill: "#054089"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.646 19.4352C26.6521 18.8387 27.1406 18.3599 27.737 18.3659L31.8611 18.4071C32.4576 18.4131 32.9363 18.9015 32.9305 19.4981C32.9244 20.0946 32.436 20.5734 31.8395 20.5673L27.7154 20.526C27.1189 20.5202 26.6402 20.0317 26.646 19.4352Z",
    fill: "#054089"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6487 27.946C26.6902 27.3509 27.2065 26.9022 27.8014 26.9438L31.9158 27.2314C32.5108 27.2729 32.9597 27.789 32.918 28.3841C32.8763 28.9793 32.3602 29.428 31.7652 29.3863L27.6509 29.0988C27.0557 29.0573 26.607 28.5412 26.6487 27.946Z",
    fill: "#054089"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7984 34.2114C27.1038 33.6989 27.7668 33.5313 28.2793 33.8368L31.8218 35.9483C32.3342 36.2537 32.5021 36.9167 32.1966 37.4292C31.8911 37.9416 31.2281 38.1095 30.7157 37.804L27.1732 35.6923C26.6608 35.3868 26.4929 34.7238 26.7984 34.2114Z",
    fill: "#054089"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4721 38.7634C9.9458 38.4825 9.29145 38.6815 9.01063 39.208L7.06909 42.8466C6.78827 43.3729 6.98728 44.0273 7.5136 44.3081C8.03993 44.589 8.69425 44.39 8.97509 43.8635L10.9166 40.2249C11.1975 39.6986 10.9984 39.0442 10.4721 38.7634Z",
    fill: "#054089"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3008 39.3545C23.8273 39.0736 24.4814 39.2726 24.7623 39.7988L26.704 43.4375C26.9846 43.964 26.7856 44.6183 26.2594 44.8992C25.7331 45.18 25.0787 44.9808 24.7979 44.4546L22.8564 40.8159C22.5756 40.2895 22.7745 39.6353 23.3008 39.3545Z",
    fill: "#054089"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9442 41.0467C16.3477 41.0357 15.8554 41.5103 15.8444 42.1068L15.7683 46.2302C15.7573 46.8267 16.2319 47.3192 16.8284 47.3303C17.4249 47.3411 17.9174 46.8666 17.9284 46.2702L18.0043 42.1465C18.0153 41.5501 17.5407 41.0577 16.9442 41.0467Z",
    fill: "#054089"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.222 14.1569C12.222 12.9638 13.1893 11.9966 14.3825 11.9966C15.5754 11.9966 16.5428 12.9638 16.5428 14.1569C16.5428 15.3501 15.5754 16.3173 14.3825 16.3173C13.1893 16.3173 12.222 15.3501 12.222 14.1569Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9144 32.9152C17.9144 31.7221 18.8816 30.7549 20.0748 30.7549C21.2677 30.7549 22.2351 31.7221 22.2351 32.9152C22.2351 34.1084 21.2677 35.0756 20.0748 35.0756C18.8816 35.0756 17.9144 34.1084 17.9144 32.9152Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70609 12.3894C7.89795 11.8246 7.59559 11.2111 7.03072 11.0193L3.12557 9.69281C2.56068 9.50096 1.94723 9.80332 1.75537 10.3682C1.56351 10.9331 1.8659 11.5465 2.43076 11.7384L6.33592 13.0648C6.90078 13.2567 7.51423 12.9543 7.70609 12.3894Z",
    fill: "#054089"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28429 19.4558C7.27832 18.8593 6.78992 18.3806 6.19338 18.3865L2.0693 18.4278C1.47276 18.4338 0.994032 18.9222 0.999994 19.5187C1.00596 20.1152 1.49439 20.5939 2.0909 20.5881L6.21498 20.5468C6.81152 20.5408 7.29027 20.0524 7.28429 19.4558Z",
    fill: "#054089"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76097 27.6586C7.71938 27.0634 7.20323 26.6147 6.60813 26.6562L2.49387 26.9438C1.89876 26.9855 1.45004 27.5016 1.49162 28.0967C1.53321 28.6917 2.04936 29.1404 2.64447 29.0989L6.75872 28.8114C7.35383 28.7697 7.80255 28.2536 7.76097 27.6586Z",
    fill: "#054089"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32537 34.2114C7.01992 33.6989 6.35689 33.5313 5.84446 33.8368L2.30181 35.9483C1.78938 36.2537 1.62158 36.9167 1.92703 37.4292C2.23248 37.9416 2.89549 38.1095 3.40792 37.804L6.9506 35.6923C7.46303 35.3868 7.63082 34.7238 7.32537 34.2114Z",
    fill: "#054089"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisease);
export default __webpack_public_path__ + "static/media/disease.f0ab4d2b.svg";
export { ForwardRef as ReactComponent };